import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { ArtifactTypeSchema } from "@/types";
import { layoutStore, selectionStore, useScreen } from "@/hooks";
import { TypeButtons } from "@/components/common";


/**
 * Buttons for changing which artifact types are visible.
 */
const __default__ = {
  name: "VisibleTypeButtons",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { smallWindow } = useScreen();

const hiddenTypes = computed(() => selectionStore.ignoreTypes);

/**
 * Toggles whether a type is visible.
 * @param option - The type to toggle.
 */
function handleClick(option: ArtifactTypeSchema) {
  const hidden = hiddenTypes.value.find((type) => type === option.name);

  selectionStore.filterGraph({
    type: "ignore",
    ignoreType: option.name,
    action: hidden ? "remove" : "add",
  });
}

return (_ctx: any,_cache: any) => {
  return (_unref(layoutStore).isTreeMode)
    ? (_openBlock(), _createBlock(_unref(TypeButtons), {
        key: 0,
        "default-visible": !_unref(smallWindow),
        "hidden-types": hiddenTypes.value,
        class: "q-mb-sm q-mr-xs",
        onClick: handleClick
      }, null, 8, ["default-visible", "hidden-types"]))
    : _createCommentVNode("", true)
}
}

})